<odl-dialog
  class="note-dialog"
  [label]="'SHARE' | translate"
  [open]="true"
  (odl-close)="dialogClosed.emit()"
>
  <div class="note-dialog-wrapper share">
    <div class="note-dialog-wrapper__section">
      <span class="note-dialog-wrapper__label">{{ 'DIALOG.SHARE.HIGHLIGHT' | translate }}</span>
      <div class="note-dialog-wrapper__quote" [style.--note-color]="colorMap[note()!.color]">
        <span class="note-dialog-wrapper__highlight" [nrEllipsis]="8">
          {{ note()!.selectedText }}
        </span>
      </div>
    </div>

    @if (note()!.notes) {
      <odl-checkbox [checked]="includeNote()" (odl-input)="toggleIncludeNote($event)">
        {{ 'DIALOG.SHARE.INCLUDE_NOTE' | translate }}
      </odl-checkbox>

      @if (includeNote()) {
        <div class="note-dialog-wrapper__section">
          <span class="note-dialog-wrapper__label">{{ 'NOTE' | translate }}</span>
          <span class="note-dialog-wrapper__note-box">{{ note()!.notes }}</span>
        </div>
      }
    }
  </div>
  <div slot="footer" class="note-dialog-wrapper__footer share">
    <odl-button (click)="shareNoteLink()" id="close-button">
      {{ 'DIALOG.BUTTONS.COPY_LINK' | translate }}
    </odl-button>
  </div>
</odl-dialog>
